import { httpServer as request } from '@/interceptors/http'
const apiUri = {
  // 获取企业jsapi_ticket
  getCorpTicket: '/fhz-qywx/anon/js/ticket/getCorpTicket',
  // 获取应用jsapi_ticket
  getAgentTicket: '/fhz-qywx/anon/js/ticket/getAgentTicket',
  // 获取企业js签名
  getSdkSign: '/fhz-qywx/anon/js/ticket/sdkSign',
  // 获取企业、应用ID
  getAgentConfig: '/fhz-qywx/anon/js/ticket/getAgentConfig',
  // getUserInfo
  getUserInfo: '/fhz-qywx/anon/auth2/getUserInfo',
  // 获取组织+岗位å
  getListOrgPos: '/fhz-iam/system/organization/listOrgPos',
  // 获取物资列表
  listMaterials: '/fhz-material/item/materials/detail/page',
  // 根据字典类型获取字典数据
  getDicts: '/fhz-iam/system/dict/data/getDictDataByType',
  // 获取客户（往来单位）列表
  getCustomerList: '/fhz-customer/customer/page',
  // 根据字典类型获取字典数据
  getDictsData: '/fhz-iam/system/dict/data/getDictDataByTypeQywx',
}
export function getCorpTicket(params) {
  return request.get(apiUri.getCorpTicket, params)
}

export function getAgentTicket(params) {
  return request.get(apiUri.getAgentTicket, params)
}

export function getSdkSign(params) {
  return request.post(apiUri.getSdkSign, params)
}

export function getAgentConfig(params) {
  return request.get(apiUri.getAgentConfig, params)
}

// getUserInfo
export function getUserInfo(params) {
  return request.get(apiUri.getUserInfo, params)
}

export function getListOrgPos(params) {
  return request.get(apiUri.getListOrgPos, params)
}

export function listMaterials(params) {
  return request.post(apiUri.listMaterials, params)
}

export function getDicts(params) {
  return request.get(apiUri.getDicts, params)
}

export function getCustomerList(params) {
  return request.post(apiUri.getCustomerList, params)
}

export function getDictsData(params) {
  return request.get(apiUri.getDictsData, params)
}
